import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Sparkles, Loader2, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Success-Landung nach Stripe-Checkout für Marathon-Tickets.
 * Pollt Payment-Status, zeigt Ticket-Code, weist auf E-Mail hin.
 */
export default function MarathonErfolg() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, ok: false, code: "", total: 0 });

  useEffect(() => {
    if (!sessionId) { setState({ loading: false, ok: false }); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid" && data.fulfillment) {
          const fill = data.fulfillment;
          const item = fill.items?.[0] || fill;
          setState({ loading: false, ok: true, code: item.code || "", total: item.total || 0, series: item.series_name || "" });
          return;
        }
        if (attempts >= 20) {
          setState({ loading: false, ok: true, code: "", total: 0, pending: true });
          return;
        }
        setTimeout(poll, 1500);
      } catch {
        if (attempts >= 5) setState({ loading: false, ok: false });
        else setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#050505] text-[#F5F0E6] flex flex-col" data-testid="marathon-success-page">
      <div className="px-8 py-6 border-b border-[#1A1A1A] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Sparkles size={22} className="text-[#D4AF37]" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-[#D4AF37]">The Movie House</div>
            <div className="font-heading text-xl">Marathon · Ticket</div>
          </div>
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        {state.loading ? (
          <div className="text-center">
            <Loader2 size={48} className="text-[#D4AF37] mx-auto animate-spin" />
            <div className="mt-4 text-lg text-[#A8A398]">Zahlung wird bestätigt …</div>
          </div>
        ) : state.ok ? (
          <div className="max-w-xl text-center space-y-6">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#D4AF37]/15 border-2 border-[#D4AF37]">
              <CheckCircle2 size={44} className="text-[#D4AF37]" />
            </div>
            <div>
              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl">Danke!</h1>
              <div className="text-xl text-[#A8A398] mt-2">Deine Marathon-Zahlung war erfolgreich.</div>
            </div>
            {state.code && (
              <div className="card-lux p-6 inline-block">
                <div className="text-[10px] uppercase tracking-[0.5em] text-[#D4AF37]">Dein Ticket-Code</div>
                <div className="font-mono text-3xl text-[#EEDC82] mt-2" data-testid="marathon-success-code">{state.code}</div>
                {state.total > 0 && (
                  <div className="text-sm text-[#A8A398] mt-2">Bezahlt: {Number(state.total).toFixed(2)} €</div>
                )}
              </div>
            )}
            <div className="text-lg text-[#A8A398] inline-flex items-center gap-2 justify-center">
              <Mail size={18} className="text-[#D4AF37]" />
              Wir haben dir das Ticket als PDF an deine E-Mail geschickt.
            </div>
            {state.pending && (
              <div className="text-sm text-[#EEDC82] border border-[#8B7328]/40 bg-[#8B7328]/10 rounded px-4 py-3">
                Deine Zahlung wird gerade abgeschlossen — du bekommst das Ticket per Mail sobald sie durch ist.
              </div>
            )}
            <Link to="/" className="inline-block mt-4 border border-[#D4AF37]/60 text-[#D4AF37] px-6 py-2.5 rounded text-xs uppercase tracking-widest hover:bg-[#D4AF37]/10">
              Zurück zur Startseite
            </Link>
          </div>
        ) : (
          <div className="text-center">
            <div className="text-lg text-[#EE9CA1] mb-4">Zahlung konnte nicht bestätigt werden.</div>
            <Link to="/" className="border border-[#D4AF37]/60 text-[#D4AF37] px-6 py-2.5 rounded text-xs uppercase tracking-widest hover:bg-[#D4AF37]/10">
              Zurück zur Startseite
            </Link>
          </div>
        )}
      </div>
      <div className="border-t border-[#1A1A1A] px-8 py-4 text-center text-[10px] uppercase tracking-[0.4em] text-[#575148]">
        THE MOVIE HOUSE · Cinema OS
      </div>
    </div>
  );
}
